import { t } from '@/i18n';

import { AppRoutes } from './routes.types';

export const ROUTES: AppRoutes = {
    companies: {
        title: t('companies'),
        route: '/companies',
        componentPath: 'Companies',
        component: 'CompaniesPage',
        isPrivate: true,
    },
    company: {
        title: t('company'),
        route: '/company',
        componentPath: 'Companies',
        component: 'CompanyPage',
        isPrivate: true,
    },
    customerService: {
        title: t('customerService'),
        route: '/customerService',
        componentPath: 'CustomerService',
        component: 'CustomerServicePage',
        isPrivate: true,
    },
    discount: {
        title: t('discountCode'),
        route: '/discount',
        componentPath: 'Discounts',
        component: 'DiscountPage',
        isPrivate: true,
    },
    discounts: {
        title: t('discountCodes'),
        route: '/discounts',
        componentPath: 'Discounts',
        component: 'DiscountsPage',
        isPrivate: true,
    },
    enclosure: {
        title: t('enclosure'),
        route: '/enclosure',
        componentPath: 'Enclosures',
        component: 'EnclosurePage',
        isPrivate: true,
    },
    enclosures: {
        title: t('enclosures'),
        route: '/enclosures',
        componentPath: 'Enclosures',
        component: 'EnclosuresPage',
        isPrivate: true,
    },
    event: {
        title: t('event'),
        route: '/event',
        componentPath: 'Events',
        component: 'EventPage',
        isPrivate: true,
    },
    events: {
        title: t('events'),
        route: '/events',
        componentPath: 'Events',
        component: 'EventsPage',
        isPrivate: true,
    },
    incidence: {
        title: t('incidence'),
        route: '/incidence',
        componentPath: 'CustomerService',
        component: 'IncidencePage',
        isPrivate: true,
    },
    login: {
        title: t('login'),
        route: '/login',
        componentPath: 'Auth',
        component: 'LoginPage',
        isPrivate: false,
    },
    logout: {
        title: t('login'),
        route: '/logout',
        componentPath: 'Auth',
        component: 'LogoutPage',
        isPrivate: false,
    },
    rememberUser: {
        title: t('rememberUser'),
        route: '/forgetUser',
        componentPath: 'Auth',
        component: 'RememberUserPage',
        isPrivate: false,
    },
    changePassword: {
        title: t('rememberUser'),
        route: '/forgetUser/:token',
        componentPath: 'Auth',
        component: 'RememberUpdatePasswordPage',
        isPrivate: false,
    },
    confirmPassword: {
        title: t('changePassword'),
        route: '/changePassword/:token',
        componentPath: 'Auth',
        component: 'ConfirmUpdatePasswordPage',
        isPrivate: false,
    },
    leadIncidence: {
        title: t('nonSubscriberMessage'),
        route: '/leadIncidence',
        componentPath: 'CustomerService',
        component: 'LeadIncidencePage',
        isPrivate: true,
    },
    operation: {
        title: t('operation'),
        route: '/operation',
        componentPath: 'Operations',
        component: 'OperationPage',
        isPrivate: true,
    },
    operations: {
        title: t('operations'),
        route: '/operations',
        componentPath: 'Operations',
        component: 'OperationsPage',
        isPrivate: true,
    },
    report: {
        title: t('report'),
        route: '/report',
        componentPath: 'Reports',
        component: 'ReportPage',
        isPrivate: true,
    },
    reports: {
        title: t('reports'),
        route: '/reports',
        componentPath: 'Reports',
        component: 'ReportsPage',
        isPrivate: true,
    },
    root: {
        route: '/',
        componentPath: 'Home',
        component: 'HomePage',
        isPrivate: true,
    },
    settings: {
        title: t('settings'),
        route: '/settings',
        componentPath: 'Home',
        component: 'HomePage',
        isPrivate: true,
    },
    settlements: {
        title: t('settlements'),
        route: '/settlements',
        componentPath: 'Home',
        component: 'HomePage',
        isPrivate: true,
    },
    subscriber: {
        title: t('subscriber'),
        route: '/subscriber',
        componentPath: 'Subscribers',
        component: 'SubscriberPage',
        isPrivate: true,
    },
    subscribers: {
        title: t('subscribers'),
        route: '/subscribers',
        componentPath: 'Subscribers',
        component: 'SubscribersPage',
        isPrivate: true,
    },
    subscriptions: {
        title: t('subscriptions'),
        route: '/subscriptions',
        componentPath: 'Subscriptions',
        component: 'SubscriptionsPage',
        isPrivate: true,
    },
    templates: {
        title: t('generalTemplates'),
        route: '/templates',
        componentPath: 'Templates',
        component: 'TemplatePage',
        isPrivate: true,
    },
    userManagement: {
        title: t('userManagement'),
        route: '/userManagement',
        componentPath: 'UserManagement',
        component: 'UserManagementPage',
        isPrivate: true,
    },
    webpage: {
        title: t('webEdition'),
        route: '/webpage',
        componentPath: 'WebEdition',
        component: 'WebEditionPage',
        isPrivate: true,
    },
    webpages: {
        title: t('webEdition'),
        route: '/webpages',
        componentPath: 'WebEdition',
        component: 'WebEditionsPage',
        isPrivate: true,
    },
    errorNotFound: {
        title: t('pageNotFound'),
        route: '*',
        componentPath: 'Errors',
        component: 'ErrorNotFoundPage',
        isPrivate: false,
    },
};
